import { ActionMenuItem, BaseActions } from "../../../components/action-menu/ActionMenuItem";
import { VirtualizedListItem } from "../../../components/virtualized-list/VirtualizedList";
import { DayOfWeekEnum, IAlarmScheduleModel } from "../../../services/alarm-schedule-data-service/Models";

export enum AlarmScheduleListActionEnum {
    Add = 'add',
    Edit = 'edit',
    Delete = 'delete',
    EditAlarmScheme = 'editalarmscheme'
}

export type AlarmScheduleListActionItem = {
    action: AlarmScheduleListActionEnum | BaseActions
} & ActionMenuItem;

export type AlarmScheduleItem = {

} & IAlarmScheduleModel & VirtualizedListItem;

const AlarmScheduleListUtils = {

    getDaysOfWeekText: (daysOfWeek:  DayOfWeekEnum[]): string => {

        const text = daysOfWeek.map(o => {
            switch (o) {
                case DayOfWeekEnum.Sunday:
                    return "Sundays";
    
                case DayOfWeekEnum.Monday:
                    return "Mondays";
    
                case DayOfWeekEnum.Tuesday:
                    return "Tuesdays";
    
                case DayOfWeekEnum.Wednesday:
                    return "Wednesdays";
    
                case DayOfWeekEnum.Thursday:
                    return "Thursdays";
    
                case DayOfWeekEnum.Friday:
                    return "Fridays";
    
                case DayOfWeekEnum.Saturday:
                    return "Saturdays";
    
                default: 
                    return "";
                                                                                        
            }
    
        });

        return text.join(', ');
    },

}

export default AlarmScheduleListUtils;

